import { FaStar, FaHeart } from 'react-icons/fa';
import { ImTicket } from 'react-icons/im';
import FilledImage from 'src/components/molecules/FilledImage';
import EventDetailsList from 'src/components/molecules/EventDetailsList';
import DateStamp from 'src/components/atoms/DateStamp';
import BoxTitle from 'src/components/atoms/BoxTitle';
import BoxHighlight from 'src/components/atoms/BottomRightBoxHighlight';
import EventCardTags from 'src/components/molecules/EventCardTags';
import Text from 'src/models/Text';
import EventLink from '../../atoms/EventLink';
import { usePluginConfig } from '../../../contexts/pluginContext';
import AdaptiveEventImage from "../../molecules/AdaptiveEventImage"

const PictureListItem = ({
  event,
  imagePriority,
  isFeatured,
  isEditorsPick,
  extraClasses,
  itemRef,
  children,
}) => {
  const publisherSettings = usePluginConfig().publisherSettings;
  const text = new Text(publisherSettings);

  const Highlight = () => {
    if (isEditorsPick) {
      return (
        <BoxHighlight color="background-theme">
          <span className="text-theme">
            <FaHeart className="inline-block mr-1 -mt-0.5" />{' '}
            {text.for('editors_pick_badge_text')}
          </span>
        </BoxHighlight>
      );
    }

    if (isFeatured) {
      return (
        <BoxHighlight color="background-featured-theme">
          <span className="text-featured-theme">
            <FaStar className="inline-block mr-1 -mt-1" />{' '}
            {text.for('featured_events_badge_text')}
          </span>
        </BoxHighlight>
      );
    }

    if (event.isTicketed) {
      return (
        <BoxHighlight color="background-featured-theme">
          <span className="text-featured-theme">
            <ImTicket className="inline-block -mt-1 mr-1" />{' '}
            {text.for('buy_tickets_badge_text')}
          </span>
        </BoxHighlight>
      );
    }

    return null;
  };

  const borderColor = () => {
    if (isEditorsPick) {
      return 'border-editors-pick-theme';
    }
    if (isFeatured || event.isTicketed) {
      return 'border-featured-theme';
    }
    return 'border-white';
  };

  return (
    <div
      className={`c-card block row-span-2 relative @md:rounded-t overflow-hidden bg-white rounded subtle-shadow border relative ${borderColor()} ${extraClasses}`}
      ref={itemRef}
    >
      {children}
        <div className="flex flex-col h-full">
          <EventLink key={event.id} href={event.href} event={event}>
            <div className="flex-grow">
              <div className="absolute top-3 z-10">
                <DateStamp event={event} />
              </div>

              <div className="relative image-placeholder aspect-video ev-max-h-170">
                {event.imageUrl && (
                  <AdaptiveEventImage
                    src={event.imageUrl}
                    alt={event.title}
                    loading={imagePriority ? 'eager' : 'lazy'}
                  />
                )}
                <div className="z-10">
                  <Highlight />
                </div>
              </div>
              <div className="w-full h-28">
                <div className="mx-5 mt-4 text-lg">
                  <BoxTitle
                    title={event.title}
                    extraClasses={isEditorsPick ? 'underline' : ''}
                  />
                </div>

                <EventDetailsList event={event} />
              </div>
            </div>
          </EventLink>
          <EventCardTags event={event} />
        </div>
    </div>
  );
};

export default PictureListItem;
